export const CV_URL =
  "https://docs.google.com/document/d/11rR_BGeWAXE_5ODDV9QDs_CPHy4admtu35OGWsgVt4E/edit";

export const DESKTOP_BREAKPOINT = 950;
